import { ROUTES } from '@/app/routes';
import { SENDER_ROUTES } from '@/app/sender-routes';
import { isSenderApp } from '@/lib/app-mode';

export type SenderRouteMap = {
	auth: string;
	hub: string;
	send: string;
	sendOne: string;
	accounts: string;
	runs: string;
	run: string;
	console: string;
	more: string;
	scenarios: string;
	scenarioNew: string;
	stats: string;
	settings: string;
	authJobs: string;
	overview: string;
	spammer: string;
	spammerSettings: string;
	spammerConsole: string;
	sessions: string;
	launch: string;
};

const panelSenderRoutes: SenderRouteMap = {
	auth: ROUTES.auth,
	hub: ROUTES.sender,
	send: `${ROUTES.sender}/send`,
	sendOne: `${ROUTES.sender}/send/one`,
	accounts: `${ROUTES.sender}/accounts`,
	runs: ROUTES.senderRuns,
	run: ROUTES.senderRun,
	console: `${ROUTES.sender}/console`,
	more: `${ROUTES.sender}/more`,
	scenarios: `${ROUTES.sender}/scenarios`,
	scenarioNew: `${ROUTES.sender}/scenarios/new`,
	stats: `${ROUTES.sender}/stats`,
	settings: ROUTES.senderSettings,
	authJobs: ROUTES.senderAuthJobs,
	overview: ROUTES.senderOverview,
	spammer: ROUTES.senderSpammer,
	spammerSettings: ROUTES.senderSpammerSettings,
	spammerConsole: ROUTES.senderSpammerConsole,
	sessions: ROUTES.senderSessions,
	launch: ROUTES.senderLaunch,
};

export const senderRoutes: SenderRouteMap = isSenderApp ? SENDER_ROUTES : panelSenderRoutes;

/** App-relative tail (`/send?mode=batch`) → current surface path. */
export function senderHref(tail: string): string {
	if (isSenderApp) return tail;
	if (tail === '/' || tail === '') return ROUTES.sender;
	return `${ROUTES.sender}${tail.startsWith('/') ? tail : `/${tail}`}`;
}
